import { graphql, useStaticQuery } from "gatsby"
import { useLocale } from ".."

export const useBusinessQuery = () => {
  const locale = useLocale()

  const {
    allContentfulDigitupStructuredDataSchema: { edges },
  } = useStaticQuery(graphql`
    query DigitupStructuredDataSchemaQuery {
      allContentfulDigitupStructuredDataSchema {
        edges {
          node {
            node_locale
            businessName
            addressLine
            city
            region
            country
            reviewAuthor
            eventTitle
            locationName
            streetAddress
            addressLocality
            addressRegion
            addressCountry
            image {
              gatsbyImageData
              file {
                url
              }
            }
            eventDescription
            organizerName
            eventPerformer
          }
        }
      }
    }
  `)

  const localeData = locale
    ? edges.filter(({ node }) => node.node_locale === locale)
    : edges.filter(({ node }) => node.node_locale === "en-US")
  const site = localeData.reduce((acc, val) => ({ ...acc, ...val.node }), {})

  return site
}
